import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux';
import SharedLinks from '../SharedLinks';
import SharePlaybookDialog from '../SharePlaybookDialog';
import { useNavigate, useSearchParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { TAlert } from '../../../types/types';
import { areNestedObjectsEqual } from '../../CommonFunctions/CommonFunctions';
import { ignoreKeys } from './constants';
import { resetAllStates } from '../../../redux/TabTile/TabTileActionsAndMultipleDispatches';

interface DataViewerHeaderProps {
  showSaveWarning: boolean;
  disableEdit?: boolean;
  currPlaybook: () => any;
  setSaveFromHomeIcon: (value: boolean) => void;
  setSaveModal: (value: boolean) => void;
  setOpenSaveCalculationDialogFromHomeIcon: (value: boolean) => void;
  TextColor: string;
}

const DataViewerHeader = ({
  showSaveWarning,
  disableEdit,
  currPlaybook,
  setSaveFromHomeIcon,
  setSaveModal,
  setOpenSaveCalculationDialogFromHomeIcon,
  TextColor,
}: DataViewerHeaderProps) => {
  const { playbookState } = useSelector((state: RootState) => ({
    playbookState: state.playBookState,
  }));

  const [showShareDialog, setShowShareDialog] = useState(false);
  const [openShareDialog, setopenShareDialog] = useState(false);

  const [alert, setAlert] = useState<TAlert | null>(null);
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  const [searchParams] = useSearchParams();

  const handleClose = () => {
    if (disableEdit) {
      dispatch(resetAllStates());
      navigate('/');
    }

    if (
      !areNestedObjectsEqual(
        sessionStorage.getItem(`pb_id_${playbookState.playBookUid}`) || '',
        JSON.stringify(currPlaybook()),
        ignoreKeys,
      )
    ) {
      setSaveFromHomeIcon(true);
      setOpenSaveCalculationDialogFromHomeIcon(true);
    } else {
      dispatch(resetAllStates());
      navigate('/');
    }
  };

  const handleShareIconClick = () => {
    if (!playbookState.playBookUid) {
      setAlert({
        severity: 'error',
        message: 'Please save the Playbook before sharing it.',
      });
      return;
    }

    const { access } = JSON.parse(localStorage.getItem('accountInfo') || '{}');
    sessionStorage.setItem('accessType', access || '');

    if (access === 'community') {
      setShowShareDialog(true);
    } else {
      setopenShareDialog(true);
    }
  };

  return (
    <>
      <div
        className="playbookNameWrapper"
        style={{ display: 'flex', alignItems: 'center', marginLeft: '25px' }}
      >
        {playbookState?.playBookName ? (
          <div
            className="playbookName"
            style={{ color: TextColor }}
            title={`Playbook Name: ${playbookState?.playBookName}\n${
              playbookState.description !== null ? playbookState.description : ''
            }`}
          >
            {playbookState?.playBookName}
          </div>
        ) : (
          <div
            className="unsavedPlaybookName"
            title="Unsaved Playbook"
            style={{ color: TextColor }}
          >
            Unsaved Playbook
          </div>
        )}

        {playbookState?.playBookName && (
          <IconButton
            onClick={handleShareIconClick}
            title={'Share Playbook'}
            sx={{
              marginLeft: '10px',
              padding: '0.2rem',
              '&:hover': {
                backgroundColor:
                  TextColor === '#ffffff'
                    ? 'rgba(255, 255, 255, 0.1)' // Light overlay for dark mode
                    : 'rgba(0, 0, 0, 0.08)', // Dark overlay for light mode
              },
            }}
          >
            <img
              key={'Share'}
              style={{
                height: '18px',
                width: '18px',
                filter: TextColor === '#ffffff' ? 'brightness(0) invert(1)' : 'none',
              }}
              src={'/share.png'}
              alt={'Share Playbook'}
            />
          </IconButton>
        )}
        <IconButton
          onClick={handleClose}
          title="Close"
          sx={{
            marginLeft: '9px',
            padding: '0.2rem',
            color: TextColor,
            '&:hover': {
              backgroundColor:
                TextColor === '#ffffff'
                  ? 'rgba(255, 255, 255, 0.1)' // Light overlay for dark mode
                  : 'rgba(0, 0, 0, 0.08)', // Dark overlay for light mode
            },
          }}
        >
          <CloseIcon
            sx={{
              height: '18px',
              width: '18px',
              fontSize: '1.2rem',
            }}
          />
        </IconButton>
      </div>

      <SharePlaybookDialog
        open={openShareDialog}
        onClose={() => setopenShareDialog(false)}
        playBookUid={playbookState.playBookUid}
      />

      {showShareDialog && (
        <SharedLinks
          playBookId={playbookState.playBookUid}
          showPopup={showShareDialog}
          handleCloseButtonClick={() => setShowShareDialog(false)}
        />
      )}
    </>
  );
};

export default DataViewerHeader;
